import backendRequest from './index.js';

export const createRole = (role) => backendRequest('POST', '/permissions/create-role', { role });

export const deleteRole = (role) => backendRequest('POST', '/permissions/delete-role', { role });

export const assignPermissionToRole = (role, permission) =>
    backendRequest('POST', '/permissions/assign-permission-to-role', {
        role,
        permission,
    });

export const getPermissions = () => backendRequest('GET', '/permissions/get-all-permissions');

export const deletePermissionFromRole = (role, permission) =>
    backendRequest('POST', '/permissions/delete-permission-from-role', {
        role,
        permission,
    });
